"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _componentsBase = require("@telus-uds/components-base");
const useTypographyTheme = (variant, tokens) => {
  const viewport = (0, _componentsBase.useViewport)();
  const themeTokens = (0, _componentsBase.useThemeTokens)('Typography', tokens, variant, {
    viewport
  });
  const {
    themeOptions
  } = (0, _componentsBase.useTheme)();
  const {
    fontSize,
    lineHeight,
    ...rnStyles
  } = (0, _componentsBase.applyTextStyles)({
    ...themeTokens,
    themeOptions
  });
  return {
    ...rnStyles,
    fontSize: `${fontSize}px`,
    lineHeight: `${lineHeight}px`
  };
};
var _default = exports.default = useTypographyTheme;